import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import { Button, Modal, Form } from 'react-bootstrap';
import Style from '../common/css/HawkSoftStyle.module.scss';
import Layout from './Layout';
import { isStaging } from '../../utils/constant';
import { useAgency } from '../contexts/AgencyContext';

// import epaymintsImg from '../../Assets/images/Epaymints_v001.svg';
// import epaymintsImg from '../../Assets/images/epaymints.png';
// import revitpayImg from '../../Assets/images/RevitPayLogo.png';

const revitPayLogoUrl = 'https://revitpaysh.wpenginepowered.com/wp-content/uploads/2026/03/Revitpay-Wordmark-Dark-Blue.png';



const Navbar = () => {
    const IS_STAGING = isStaging();
    const { agency } = useAgency();
    return (<>
        {IS_STAGING && (<div className={Style.stagingBar}>STAGING</div>)}
        <header className={Style.navbar}>
            <Layout isNavbar>
                <div className={Style.navbarLogoRow}>
                    <img src={revitPayLogoUrl} className={Style.navbarLogo} alt="RevitPay" />
                    {agency?.logoUrl && (
                        <img src={agency?.logoUrl}
                            className={`${Style.navbarLogo} ${Style.agencyLogo}`}
                            alt={agency?.agencyName || 'Agency'}
                        />
                    )}
                </div>
            </Layout>
        </header>
    </>);
};
export default Navbar;